export const emailSelector = state => state.email?.get('currentEmail')
